/* eslint no-unused-vars: "off" -- 禁用未使用变量检查 */
export enum StockMangeRoute {
  StockStat = "StockManageStat",
  StockIn = "StockIn",
  StockOut = "StockOut",
  CheckRecord = "CheckRecord",
  ConsumptionOrder = "ConsumptionOrder",
  ConsumptionOrderOld = "ConsumptionOrderOld",
  StockAdjustment = "StockAdjustment",
}

export enum StockMangeCreateRoute {
  StockIn = "StockInCreate",
  StockOut = "StockOutCreate",
  CheckRecord = "CheckRecordCreate",
  StockAdjustment = "StockAdjustmentCreate",
}

export enum StockMangeCreateDetailRoute {
  StockIn = "StockInDetail",
  StockOut = "StockOutDetail",
  CheckRecord = "CheckRecordDetail",
  ConsumptionOrder = "ConsumptionOrderDetail",
  StockAdjustment = "StockAdjustmentDetail",
}

export enum MembershipManageRoute {
  MembershipManage = "MembershipManage",
  OperationRecord = "MembershipOperationRecord",
  MemberDetail = "MemberDetail",
  ConsumptionRecord = "ConsumptionRecord",
  TopUpRecord = "TopUpRecord",
}

export enum MembershipCreditRoute {
  CreditShop = "CreditShop",
  CreditConsumptionRecords = "CreditConsumptionRecords",
  CreditGetRecords = "CreditGetRecords",
}

export enum MembershipChargeRuleRoute {
  ChargeRule = "ChargeRule",
  AddChargeRule = "AddChargeRule",
  EditChargeRule = "EditChargeRule",
}

export enum MembershipDashboardRoute {
  MemberConsume = "MemberConsume",
  MemberTopUp = "MemberTopUp",
}

export enum MembershipLevelRoute {
  MembershipLevelSetting = "MembershipLevelSetting",
  AddMembershipLevel = "AddMembershipLevel",
  EditMembershipLevel = "EditMembershipLevel",
}
